<script setup lang="ts">
import { ref, withDefaults, defineProps, computed } from 'vue'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
const emit = defineEmits<{
  (e: 'toggle'): void
}>()
type AccordionProps = {
  preLabel?: string
  label?: string
  text: string
  withLabelClass?: string
  withoutLabelClass?: string
  withIcons: boolean
  isOpen: boolean | null
}
const props = withDefaults(defineProps<AccordionProps>(), {
  isOpen: null,
})

const isShowed = (open) => (props.isOpen !== null ? props.isOpen : open)
</script>

<template>
  <div class="app-accordion-container">
    <Disclosure v-slot="{ open }">
      <DisclosureButton class="accordion-header" @click="emit('toggle')">
        <div class="accordion-title">
          <div class="accordion-pre-title-container">
            <p v-if="preLabel" class="accordion-title-pre-label">
              {{ preLabel }}
            </p>
            <p v-if="label" class="accordion-title-label">{{ label }}</p>
          </div>

          <p class="accordion-title-text">{{ text }}</p>
        </div>
        <div v-if="withIcons" class="accordion-icons">
          <Transition name="fade" mode="out-in">
            <div v-if="!isShowed(open)">
              <slot name="icon-to-open"></slot>
            </div>
            <div v-else>
              <slot name="icon-to-close"></slot>
            </div>
          </Transition>
        </div>
      </DisclosureButton>

      <DisclosurePanel v-show="isShowed(open)" static>
        <Transition name="fade">
          <div
            class="accordion-body"
            :class="[label ? withLabelClass : withoutLabelClass]"
          >
            <slot name="body"></slot></div
        ></Transition>
      </DisclosurePanel>
    </Disclosure>
  </div>
</template>

<style scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
